<template>
	<div class="home-page" @click="$store.commit('closeUserInfoBox')">
		
		<div class="app-container">
			<div class="navi-bar">
				<div class="navi-bar-box">
					<div class="top">
						<!-- <div class="logo">
							<div class="red-dot"></div>
							<div class="yellow-dot"></div>
							<div class="green-dot"></div>
						</div> -->
						<div class="user-head-image">
							<head-image :name="$store.state.userStore.userInfo.nickName" :size="38"
								:url="$store.state.userStore.userInfo.headImageThumb"
								ref="userAvatar"
								@click.native="onAvatarClick">
							</head-image>
						</div>

						<div class="menu">
							<router-link class="link" v-bind:to="'/home/chat'">
								<div class="menu-item">
									<!-- <span class="icon iconfont icon-chat"></span> -->
									<img :src="getChatIcon()" alt="" style="width: 24px;height: 24px;">
									<div v-show="unreadCount > 0" class="unread-text">{{ unreadCount }}</div>
								</div>
							</router-link>
							<router-link class="link" v-bind:to="'/home/friend'">
								<div class="menu-item">
									<!-- <span class="icon iconfont icon-friend"></span> -->
									<img :src="getFriendIcon()" alt="" style="width: 24px;height: 24px;">

								</div>
							</router-link>
							<!-- <router-link class="link" v-bind:to="'/home/group'">
								<div class="menu-item">
									<span class="icon iconfont icon-group" style="font-size: 28px"></span>
								</div>
							</router-link> -->
						</div>
					</div>

					<div class="botoom">
						<!-- <div class="bottom-item" @click="isFullscreen = !isFullscreen">
							<i class="el-icon-full-screen"></i>
						</div> -->
						<div class="bottom-item" @click="showSetting">
							<!-- <span class="icon iconfont icon-setting" style="font-size: 20px"></span> -->
							<img src="@/assets/image/icon_set@2x.png" alt="" style="width: 24px;height: 24px;">
						</div>
						<!-- <div class="bottom-item" @click="onExit()" title="退出">
							<span class="icon iconfont icon-exit"></span>
						</div> -->
					</div>
				</div>
			</div>
			<div class="content-box">
				<router-view></router-view>
			</div>


			
			<setting :visible="showSettingDialog" @close="closeSetting()"></setting>
			<user-info v-show="uiStore.userInfo.show" :pos="uiStore.userInfo.pos" :user="uiStore.userInfo.user"
				@close="$store.commit('closeUserInfoBox')"></user-info>
			<full-image :visible="uiStore.fullImage.show" :url="uiStore.fullImage.url"
				@close="$store.commit('closeFullImageBox')"></full-image>
			<rtc-private-video ref="rtcPrivateVideo"></rtc-private-video>
			<rtc-group-video ref="rtcGroupVideo"></rtc-group-video>
		</div>
	</div>
</template>

<script>
import HeadImage from '../components/common/HeadImage.vue';
import Setting from '../components/setting/Setting.vue';
import UserInfo from '../components/common/UserInfo.vue';
import FullImage from '../components/common/FullImage.vue';
import RtcPrivateVideo from '../components/rtc/RtcPrivateVideo.vue';
import RtcPrivateAcceptor from '../components/rtc/RtcPrivateAcceptor.vue';
import RtcGroupVideo from '../components/rtc/RtcGroupVideo.vue';

export default {
	components: {
		HeadImage,
		Setting,
		UserInfo,
		FullImage,
		RtcPrivateVideo,
		RtcPrivateAcceptor,
		RtcGroupVideo
	},
	data() {
		return {
			showSettingDialog: false,
			lastPlayAudioTime: new Date().getTime() - 1000,
			isFullscreen: false,
			reconnecting: false,
			imMsgQuey: [],
			activeName: 'first'
		}
	},
	methods: {
		handleClick(tab, event) {
			console.log(tab, event);
		},
		sendMsgQuery(item) {
			let activeChat = this.$store.state.chatStore.activeChat;
			let item_cp = {};
			item_cp.content = JSON.stringify(item.content);
			item_cp.template = JSON.stringify(item.template);
			item_cp.type = item.type;
			item_cp.recvId = activeChat.targetId;
			this.$http({
				url: "/immsgQuery/pushMsg",
				method: 'POST',
				data: item_cp
			}).then((e) => {
				console.log(e);
			})

		},
		isLast(template, index) {
			return index == Object.keys(template).length - 1 ? true : false;
		},
		toKeys(jsonObject) {
			return Object.keys(jsonObject);
		},
		init(chatData) {
			this.$eventBus.$on('openPrivateVideo', (rctInfo) => {
				// 进入单人视频通话
				this.$refs.rtcPrivateVideo.open(rctInfo);
			});
			this.$eventBus.$on('openGroupVideo', (rctInfo) => {
				// 进入多人视频通话
				this.$refs.rtcGroupVideo.open(rctInfo);
			});

			this.$store.dispatch("load").then(() => {
				// ws初始化
				this.$wsApi.connect(process.env.VUE_APP_WS_URL, sessionStorage.getItem("accessToken"));
				this.$wsApi.onConnect(() => {
					if (this.reconnecting) {
						this.onReconnectWs();
					} else {
						// 加载离线消息
						this.pullPrivateOfflineMessage(this.$store.state.chatStore.privateMsgMaxId);
						if (chatData) {
							let chatData_JSON= JSON.parse(decodeURIComponent(atob(chatData)));
							this.$store.commit("openChat",chatData_JSON);
							this.$store.commit("activeChatByFriendId",chatData_JSON.targetId);
						} else {
							// 如果没有chatData，检查是否需要自动选择第一个聊天
							this.$nextTick(() => {
								setTimeout(() => {
									const chatComponent = this.$children.find(child => child.$options.name === 'chat');
									if (chatComponent && chatComponent.autoSelectFirstChat) {
										chatComponent.autoSelectFirstChat();
									}
								}, 100);
							});
						}
						this.pullPrivateImMsgQuery();
					}
				});
				this.$wsApi.onMessage((cmd, msgInfo) => {
					if (cmd == 2) {
						// 关闭ws
						this.$wsApi.close(3000)
						// 异地登录，强制下线
						this.$alert("您已在其他地方登录，将被强制下线", "强制下线通知", {
							confirmButtonText: '确定',
							callback: action => {
								location.href = "/";
							}
						});

					} else if (cmd == 3) {
						// 插入私聊消息
						this.handlePrivateMessage(msgInfo);
					} else if (cmd == 4) {
						// 插入群聊消息
						this.handleGroupMessage(msgInfo);
					} else if (cmd == 5) {
						// 处理系统消息
						this.handleSystemMessage(msgInfo);
					}
				});
				this.$wsApi.onClose((e) => {
					if (e.code != 3000) {
						// 断线重连
						this.reconnectWs();
					}
				});
			}).catch((e) => {
				console.log("初始化失败", e);
			})
		},
		reconnectWs() {
			// 记录标志
			this.reconnecting = true;
			// 重新加载一次个人信息，目的是为了保证网络已经正常且token有效
			this.$store.dispatch("loadUser").then(() => {
				// 断线重连
				this.$message.error("连接断开，正在尝试重新连接...");
				this.$wsApi.reconnect(process.env.VUE_APP_WS_URL, sessionStorage.getItem(
					"accessToken"));
			}).catch(() => {
				// 10s后重试
				setTimeout(() => this.reconnectWs(), 10000)
			})
		},
		onReconnectWs() {
			// 重连成功
			this.reconnecting = false;
			// 重新加载群和好友
			const promises = [];
			promises.push(this.$store.dispatch("loadFriend"));
			promises.push(this.$store.dispatch("loadGroup"));
			Promise.all(promises).then(() => {
				// 加载离线消息
				this.pullPrivateOfflineMessage(this.$store.state.chatStore.privateMsgMaxId);
				//this.pullGroupOfflineMessage(this.$store.state.chatStore.groupMsgMaxId);
				this.$message.success("重新连接成功");
			}).catch(() => {
				this.$message.error("初始化失败");
				this.onExit();
			})
		},
		pullPrivateOfflineMessage(minId) {
			this.$store.commit("loadingPrivateMsg", true);
			//如果有就选中一个

			this.$http({
				url: "/message/private/pullOfflineMessage?minId=" + minId,
				method: 'GET'
			}).catch(() => {
				this.$store.commit("loadingPrivateMsg", false)
			})
		},
		// 获取右侧列表
		pullPrivateImMsgQuery() {
			let activeChat = this.$store.state.chatStore.activeChat;
			if (activeChat && activeChat.targetId) {
				this.$http({
					url: "/immsgQuery/list",
					method: 'POST',
					data: { recvId: activeChat.targetId }
				}).then((e) => {
					e.forEach((item) => {
						item.content = JSON.parse(item.content);
						item.template = JSON.parse(item.template);
					})
					this.imMsgQuey = e;
					// console.log(this.imMsgQuey, '<<<<<<<<<this.imMsgQuey');

				})
			}
		},
		pullGroupOfflineMessage(minId) {
			this.$store.commit("loadingGroupMsg", true)
			this.$http({
				url: "/message/group/pullOfflineMessage?minId=" + minId,
				method: 'GET'
			}).catch(() => {
				this.$store.commit("loadingGroupMsg", false)
			})
		},
		handlePrivateMessage(msg) {
			// 标记这条消息是不是自己发的
			msg.selfSend = msg.sendId == this.$store.state.userStore.userInfo.id;
			// 好友id
			let friendId = msg.selfSend ? msg.recvId : msg.sendId;
			// 会话信息
			let chatInfo = {
				type: 'PRIVATE',
				targetId: friendId
			}
			// 消息加载标志
			if (msg.type == this.$enums.MESSAGE_TYPE.LOADING) {
				this.$store.commit("loadingPrivateMsg", JSON.parse(msg.content))
				return;
			}
			// 消息已读处理，清空已读数量
			if (msg.type == this.$enums.MESSAGE_TYPE.READED) {
				this.$store.commit("resetUnreadCount", chatInfo)
				return;
			}
			// 消息回执处理,改消息状态为已读
			if (msg.type == this.$enums.MESSAGE_TYPE.RECEIPT) {
				this.$store.commit("readedMessage", {
					friendId: msg.sendId
				})
				return;
			}
			// 消息撤回
			if (msg.type == this.$enums.MESSAGE_TYPE.RECALL) {
				this.$store.commit("recallMessage", [msg, chatInfo])
				return;
			}


			if (msg.type == this.$enums.MESSAGE_TYPE.imMsgQuey) {
				this.pullPrivateImMsgQuery();
			}


			// 新增好友
			if (msg.type == this.$enums.MESSAGE_TYPE.FRIEND_NEW) {
				this.$store.commit("addFriend", JSON.parse(msg.content));
				return;
			}
			// 删除好友
			if (msg.type == this.$enums.MESSAGE_TYPE.FRIEND_DEL) {
				this.$store.commit("removeFriend", friendId);
				return;
			}
			// 单人webrtc 信令
			if (this.$msgType.isRtcPrivate(msg.type)) {
				this.$refs.rtcPrivateVideo.onRTCMessage(msg)
				return;
			}
			// 插入消息
			if (this.$msgType.isNormal(msg.type) || this.$msgType.isTip(msg.type) || this.$msgType.isAction(msg.type)) {
				let friend = this.loadFriendInfo(friendId);
				this.insertPrivateMessage(friend, msg);
			}



		},
		insertPrivateMessage(friend, msg) {
			let chatInfo = {
				type: 'PRIVATE',
				targetId: friend.id,
				showName: friend.nickName,
				headImage: friend.headImage
			};
			// 打开会话
			this.$store.commit("openChat", chatInfo);
			// 插入消息
			this.$store.commit("insertMessage", [msg, chatInfo]);
			// 播放提示音
			if (!msg.selfSend && this.$msgType.isNormal(msg.type) &&
				msg.status != this.$enums.MESSAGE_STATUS.READED) {
				this.playAudioTip();
			}
		},
		handleGroupMessage(msg) {
			// 标记这条消息是不是自己发的
			msg.selfSend = msg.sendId == this.$store.state.userStore.userInfo.id;
			let chatInfo = {
				type: 'GROUP',
				targetId: msg.groupId
			}
			// 消息加载标志
			if (msg.type == this.$enums.MESSAGE_TYPE.LOADING) {
				this.$store.commit("loadingGroupMsg", JSON.parse(msg.content))
				return;
			}
			// 消息已读处理
			if (msg.type == this.$enums.MESSAGE_TYPE.READED) {
				// 我已读对方的消息，清空已读数量
				this.$store.commit("resetUnreadCount", chatInfo)
				return;
			}
			// 消息回执处理
			if (msg.type == this.$enums.MESSAGE_TYPE.RECEIPT) {
				// 更新消息已读人数
				let msgInfo = {
					id: msg.id,
					groupId: msg.groupId,
					readedCount: msg.readedCount,
					receiptOk: msg.receiptOk
				};
				this.$store.commit("updateMessage", [msgInfo, chatInfo])
				return;
			}
			// 消息撤回
			if (msg.type == this.$enums.MESSAGE_TYPE.RECALL) {
				this.$store.commit("recallMessage", [msg, chatInfo])
				return;
			}
			// 新增群
			if (msg.type == this.$enums.MESSAGE_TYPE.GROUP_NEW) {
				this.$store.commit("addGroup", JSON.parse(msg.content));
				return;
			}
			// 删除群
			if (msg.type == this.$enums.MESSAGE_TYPE.GROUP_DEL) {
				this.$store.commit("removeGroup", msg.groupId);
				return;
			}
			// 群视频信令
			if (this.$msgType.isRtcGroup(msg.type)) {
				this.$nextTick(() => {
					this.$refs.rtcGroupVideo.onRTCMessage(msg);
				})
				return;
			}
			// 插入群聊消息
			if (this.$msgType.isNormal(msg.type) || this.$msgType.isTip(msg.type) || this.$msgType.isAction(msg.type)) {
				let group = this.loadGroupInfo(msg.groupId);
				this.insertGroupMessage(group, msg);
			}
		},
		insertGroupMessage(group, msg) {
			let chatInfo = {
				type: 'GROUP',
				targetId: group.id,
				showName: group.showGroupName,
				headImage: group.headImageThumb
			};
			// 打开会话
			this.$store.commit("openChat", chatInfo);
			// 插入消息
			this.$store.commit("insertMessage", [msg, chatInfo]);
			// 播放提示音
			if (!msg.selfSend && msg.type <= this.$enums.MESSAGE_TYPE.VIDEO &&
				msg.status != this.$enums.MESSAGE_STATUS.READED) {
				this.playAudioTip();
			}
		},
		handleSystemMessage(msg) {
			// 用户被封禁
			if (msg.type == this.$enums.MESSAGE_TYPE.USER_BANNED) {
				this.$wsApi.close(3000);
				this.$alert("您的账号已被管理员封禁,原因:" + msg.content, "账号被封禁", {
					confirmButtonText: '确定',
					callback: action => {
						this.onExit();
					}
				});
				return;
			}
		},
		onExit() {
			this.$wsApi.close(3000);
			sessionStorage.removeItem("accessToken");
			location.href = "/";
		},
		playAudioTip() {
			// 离线消息不播放铃声
			if (this.$store.getters.isLoading()) {
				return;
			}
			// 防止过于密集播放
			if (new Date().getTime() - this.lastPlayAudioTime > 1000) {
				this.lastPlayAudioTime = new Date().getTime();
				let audio = new Audio();
				let url = require(`@/assets/audio/tip.wav`);
				audio.src = url;
				audio.play();
			}

		},
		showSetting() {
			this.showSettingDialog = true;
		},
		closeSetting() {
			this.showSettingDialog = false;
		},
		loadFriendInfo(id) {
			let friend = this.$store.getters.findFriend(id);
			if (!friend) {
				friend = {
					id: id,
					showNickName: "未知用户",
					headImage: ""
				}
			}
			return friend;
		},
		loadGroupInfo(id) {
			let group = this.$store.getters.findGroup(id);
			if (!group) {
				group = {
					id: id,
					showGroupName: "未知群聊",
					headImageThumb: ""
				}
			}
			return group;
		},
		onAvatarClick(e) {
			e.stopPropagation(); // 防止冒泡到 home-page 导致直接关闭
			// 显示当前用户信息
			let pos = {
				x: e.clientX,
				y: e.clientY
			}
			this.$store.commit("setUserInfoBoxPos", pos);
			this.$store.commit("showUserInfoBox", this.$store.state.userStore.userInfo);
		},
		getChatIcon() {
			// 如果当前路由是聊天页面，返回active图标，否则返回普通图标
			return this.$route.path === '/home/chat' 
				? require('@/assets/image/icon_messages1@2x.png') 
				: require('@/assets/image/ICONCHAT.png');
		},
		getFriendIcon() {
			// 如果当前路由是好友页面，返回active图标，否则返回普通图标
			return this.$route.path === '/home/friend' 
				? require('@/assets/image/icon_contacts1@2x.png') 
				: require('@/assets/image/icon_contacts2@2x.png');
		}
	},
	computed: {
		uiStore() {
			return this.$store.state.uiStore;
		},
		unreadCount() {
			let unreadCount = 0;
			let chats = this.$store.state.chatStore.chats;
			chats.forEach((chat) => {
				if (!chat.delete) {
					unreadCount += chat.unreadCount
				}
			});
			return unreadCount;
		}
	},
	watch: {
		unreadCount: {
			handler(newCount, oldCount) {
				let tip = newCount > 0 ? `${newCount}条未读` : "";
				this.$elm.setTitleTip(tip);
			},
			immediate: true
		},
		'$store.state.chatStore.activeChat': {
			handler(newVal) {
				this.pullPrivateImMsgQuery();
			},
			deep: true
		},
		'$route.path': {
			handler(newPath) {
				// 路由变化时强制更新图标
				this.$forceUpdate();
				
				// 当路由跳转到聊天页面时，检查是否需要自动选择第一个聊天
				if (newPath === '/home/chat') {
					this.$nextTick(() => {
						// 延迟执行，确保Chat组件已经挂载
						setTimeout(() => {
							const chatComponent = this.$children.find(child => child.$options.name === 'chat');
							if (chatComponent && chatComponent.autoSelectFirstChat) {
								chatComponent.autoSelectFirstChat();
							}
						}, 100);
					});
				}
				// 当路由跳转到好友页面时，检查是否需要自动选择第一个好友
				if (newPath === '/home/friend') {
					this.$nextTick(() => {
						// 延迟执行，确保Friend组件已经挂载
						setTimeout(() => {
							const friendComponent = this.$children.find(child => child.$options.name === 'friend');
							if (friendComponent && friendComponent.autoSelectFirstFriend) {
								friendComponent.autoSelectFirstFriend();
							}
						}, 100);
					});
				}
			},
			immediate: true
		}
	},
	mounted() {
		let msgId = this.$route.query.msgId;
		let chatData = this.$route.query.chatData;
		this.init(chatData);
		// console.log(this.imMsgQuey, '<<<<<<<<<this.imMsgQuey');
		// console.log(this.$route.name, "当前路由");


	},
	unmounted() {
		this.$wsApi.close();
	}
}
</script>

<style scoped lang="scss">
.home-page::v-deep {
	height: 100vh;
	width: 100vw;
	display: flex;
	// justify-content: center;
	// align-items: center;
	// border-radius: 4px;
	// overflow: hidden;
	// background: var(--im-color-primary-light-9);

	.app-container {
		width: 100vw;
		height: 100vh;
		min-width: 0;
		min-height: 0;
		display: flex;
		// position: absolute;
		// border-radius: 10px;
		// overflow: hidden;
		box-shadow: var(--im-box-shadow-dark);
		// transition: 0.2s;
	}

	

	.navi-bar {
		--icon-font-size: 22px;
		--width: 64px;
		width: var(--width);
		// background: rgb(46, 46, 46);
		background: rgba(224, 224, 223, 1);
		padding-top: 20px;

		.navi-bar-box {
			height: 100%;
			display: flex;
			flex-direction: column;
			justify-content: space-between;

			.logo {
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 0 12px;
				margin-bottom: 32px;

				.red-dot {
					width: 10px;
					height: 10px;
					background: rgb(254, 96, 88);
					border-radius: 50%;
				}

				.yellow-dot {
					width: 10px;
					height: 10px;
					background: rgba(254, 188, 46, 1);
					border-radius: 50%;
				}

				.green-dot {
					width: 10px;
					height: 10px;
					background: rgba(39, 200, 64, 1);
					border-radius: 50%;
				}
			}

			.botoom {
				// margin-bottom: 30px;
			}
		}

		.user-head-image {
			display: flex;
			justify-content: center;
		}

		.menu {
			height: 180px;
			//margin-top: 10px;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-content: center;

			.link {
				text-decoration: none;
			}

			.router-link-active .menu-item {
				color: rgba(2, 122, 255, 1);
				// background: rgb(46, 46, 46);
			}

			.link:not(.router-link-active) .menu-item:hover {
				color: var(--im-color-primary-light-7);
			}

			.menu-item {
				position: relative;
				color: #fff;
				width: var(--width);
				height: 46px;
				display: flex;
				justify-content: center;
				align-items: center;
				margin-bottom: 12px;

				.icon {
					font-size: var(--icon-font-size)
				}

				.unread-text {
					position: absolute;
					background-color: var(--im-color-danger);
					left: 28px;
					top: 8px;
					color: white;
					border-radius: 30px;
					padding: 0 5px;
					font-size: var(--im-font-size-smaller);
					text-align: center;
					white-space: nowrap;
					border: 1px solid #f1e5e5;
				}
			}
		}

		.bottom-item {
			display: flex;
			justify-content: center;
			align-items: center;
			height: 50px;
			width: 100%;
			cursor: pointer;
			color: #fff;
			font-size: var(--icon-font-size);

			.icon {
				font-size: var(--icon-font-size)
			}

			&:hover {
				font-weight: 600;
				color: var(--im-color-primary-light-7);
			}
		}
	}

	.content-box {
		flex: 1;
		padding: 0;
		background-color: #fff;
		text-align: center;
	}
}
</style>